var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reload)?_c('div',{staticClass:"avue-code",style:(_vm.styleName)},[_c('pre',{directives:[{name:"highlight",rawName:"v-highlight"}]},[_vm._v("        "),_c('code',{staticClass:"javascript"},[_vm._v(_vm._s(_vm.value))]),_vm._v("\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }